import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import LinkExpiryPage from "./pages/Common/LinkExpiryPage";
import FormAnalyse from "./pages/FormAnalyse/FormAnalyse";
import FormHome from "./pages/FormHome/FormHome";
import FormMainBody from "./pages/FormMainBody/FormMainBody";
import BuilderPage from "./features/builder/BuilderPage";
import FormShare from "./pages/FormShare/FormShare";
import FormSubmit from "./pages/FormSubmit/FormSubmit";
import FormPreview from "./pages/FormPreview/FormPreview";
import FormSimplePageView from "./pages/FormSimplePageView/FormSimplePageView";

const useNewBuilder = process.env.REACT_APP_NEW_BUILDER !== 'false';
const BuilderRoute = useNewBuilder ? BuilderPage : FormMainBody;

const RoutesList = () => {
  return (
    <>
      <Routes>
        <Route path="/form_builder/form_list" element={<FormHome />}></Route>
        <Route path="/form_builder/form_edit/:id" element={<BuilderRoute />}></Route>
        <Route path="/form_builder/form_edit/:id/:langId" element={<BuilderRoute />}></Route>
        <Route path="/form_builder/form_share" element={<FormShare />}></Route>
        <Route path="/form_builder/form_analyse" element={<FormAnalyse />}></Route>
        <Route path="/form_builder/form_submit/:paramObj" element={<FormSubmit />}></Route>
        <Route path="/form_builder/form_submit/:paramObj/:langId" element={<FormSubmit />}></Route>
        <Route path="/form_builder/form_preview/:id" element={<FormPreview />}></Route>
        <Route path="/form_builder/form_preview/:id/:langId" element={<FormPreview />}></Route>
        <Route path="/form_builder/open-form/submit/:token" element={<FormSubmit />}></Route>
        <Route path="/form_builder/expired" element={<LinkExpiryPage />}></Route>
        <Route path="/form_builder/open-form/review/:token" element={<FormSubmit />}></Route>
        <Route path='*' exact={true} element={<Navigate replace to="/form_builder/form_list" />}></Route>
        <Route path="/form_builder/open-form/submit/sp/:token" element={<FormSimplePageView />}></Route>
        <Route path="/form_builder/form_submit/sp/:paramObj" element={<FormSimplePageView />}></Route>
        <Route path="/form_builder/review/:token" element={<FormSubmit />}></Route>
      </Routes>
    </>
  );
};
export default RoutesList;
